// Auth configuration (server-side)
export { auth, handlers, signIn, signOut } from './lib/auth';

// Auth provider and hooks (client-side)
export { SessionProvider, useCurrentUser } from './lib/auth-provider';

// Admin context
export { AdminProvider, useAdmin } from './lib/admin-context';
export type { SelectedCustomer } from './lib/admin-context';

// SSR-safe sessionStorage hook
export { useSessionStorage } from './lib/use-session-storage';

// Kontowechsel (beendet die Keycloak-SSO-Session, damit ein anderes Konto möglich ist)
export {
  buildAccountSwitchLogoutUrl,
  ACCOUNT_SWITCH_START_PATH,
  ACCOUNT_SWITCH_RETURN_PATH,
} from './lib/switch-account';
export type { AccountSwitchLogoutUrlOptions } from './lib/switch-account';
export {
  startAccountSwitch,
  completeAccountSwitch,
} from './lib/switch-account-client';

// Sitzungserneuerung: Erkennung + Hinweis mit Ein-Klick-Aktion
export {
  SessionRenewalNotice,
  useSessionNeedsRenewal,
  renewSession,
} from './lib/session-renewal-notice';
export { sessionNeedsRenewal, classifyAuthRejection } from './lib/session-renewal';
export {
  markSessionRejected,
  getSessionRejection,
  resetSessionRejection,
} from './lib/session-rejected-signal';
export type { AuthRejectionReason } from './lib/session-rejected-signal';

// Portal-access helper (mirrors backend AuthGuard privilege logic)
export { hasPortalAccess, PORTAL_PRIVILEGED_ROLES } from './lib/portal-access';

// Types
export type { AuthenticatedUser } from './lib/types';
